// import {dom} from './constant/dom';
import product from './components/product';
import special from './components/special';
import gallery from './components/gallery';
import header from './components/header';
import cart from './components/cart';
import search from './components/search';
import productCard from './components/product-card';
import quickbuy from './components/quickbuy';
import filter from './components/filter';
import sizeguide from './components/sizeguide';
import account from './components/account';
import popupLogin from './components/popup-login';
import lang from './components/lang';
// import backInStock from './components/back-in-stock';
import lazyload from './components/lazyload';

export default () => {
	header();
	cart();
	product();
	special();
	gallery();
	search();
	productCard();
	quickbuy();
	filter();
	sizeguide();
	account();
	popupLogin();
	lang();
	// backInStock();
	lazyload();
};
